import breakPoints from 'helpers/Styles';

const TechnicalInformation = ({ block, primaryFontColor, secondaryFontColor }) => {
  if (!block) return '';

  const { title1 } = block.primary;
  const title = title1 ? title1 : null;

  const { items } = block;

  return (
    <>
      <div className="technical_information_slice">
        <div className="technical_information_container">
          <div className="title">
            <h1> {title}</h1>
          </div>

          <div className="information_container">
            {items &&
              items.map((item, index) => (
                <div className="column_information" key={index}>
                  <div className="column_title">
                    <h1>{item.title1}</h1>
                  </div>

                  <div className="information_block_container">
                    <div className="information_block">
                      <p>{item.subtitle_one}</p>

                      <div className="block_description">
                        {item.description_one &&
                          item.description_one.map((item, index) => (
                            <div key={index}>
                              <p>{item.text}</p>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="information_block">
                      <p>{item.subtitle_two}</p>

                      <div className="block_description">
                        {item.description_two &&
                          item.description_two.map((item, index) => (
                            <div key={index}>
                              <p>{item.text}</p>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="information_block">
                      <p>{item.subtitle_three}</p>

                      <div className="block_description">
                        {item.description_three &&
                          item.description_three.map((item, index) => (
                            <div key={index}>
                              <p>{item.text}</p>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="information_block">
                      <p>{item.subtitle_four}</p>

                      <div className="block_description">
                        {item.description_four &&
                          item.description_four.map((item, index) => (
                            <div key={index}>
                              <p>{item.text}</p>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="information_block">
                      <p>{item.subtitle_five}</p>

                      <div className="block_description">
                        {item.description_five &&
                          item.description_five.map((item, index) => (
                            <div key={index}>
                              <p>{item.text}</p>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .technical_information_slice {
            width: 100%;
            background: inherit;
            padding-bottom: 50px;
            padding-top: 50px;
          }
          .title h1 {
            color: ${primaryFontColor ? primaryFontColor : ''};
            font-family: 'big_noodle_titling';
            font-size: 39px;
            letter-spacing: 0;
            line-height: 48px;
            margin: 0;
            text-align: center;
          }
          .information_container {
            display: flex;
            width: 80%;
            margin: 0 auto;
            margin-top: 50px;
            padding-left: 3%;
            max-width: 1150px;
          }
          .column_information {
            width: 50%;
            background: #242424;
            margin-right: 30px;
          }
          .column_title {
            background: #141414;
            height: 80px;
            padding-left: 30px;
            padding-top: 20px;
          }
          .column_title h1 {
            color:${primaryFontColor ? primaryFontColor : ''};
            font-family: 'big_noodle_titling';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 40px;
            margin: 0;
          }
          .information_block {
            margin-bottom: 30px;
          }
          .information_block p {
            color: ${secondaryFontColor ? secondaryFontColor : ''};
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 24px;
            margin: 0;
            margin-bottom: 10px;
          }
          .block_description p {
            color: #949494;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 20px;
          }
          .information_block_container {
            padding: 30px 50px;
          }

          @media (max-width: ${breakPoints.medium}) {
            .title h1 {
              font-size: 26px;
            }
            .information_container {
              display: block;
              width: 100%;
              padding-left: 0;
            }
            .column_information {
              width: 90%;
              margin: 0 auto;
              margin-bottom: 30px;
            }
            .column_title h1 {
              font-size: 23px;
            }
          }
        `}
      </style>
    </>
  );
};

export default TechnicalInformation;
